import type { Thresholds, WgInfo } from '../models/settings';
import { Store } from '../core/store';
import { api, PANEL_API } from './api-client';

export interface SettingsResponse {
  thresholds: Thresholds;
  wg: WgInfo;
}

/** Son bilinen ayarlar — sağlık renklendirmesi güncel eşiklerle yapılır. */
export const settingsStore = new Store<SettingsResponse | null>(null);

class SettingsService {
  async get(): Promise<SettingsResponse> {
    const res = await api.get<SettingsResponse>(`${PANEL_API}/settings`);
    settingsStore.set(res);
    return res;
  }

  /** Önbellekte varsa onu döner; yoksa yükler. */
  async ensureLoaded(): Promise<SettingsResponse> {
    return settingsStore.get() ?? this.get();
  }

  async saveThresholds(thresholds: Thresholds): Promise<Thresholds> {
    const res = await api.put<{ thresholds: Thresholds }>(
      `${PANEL_API}/settings/thresholds`,
      thresholds,
    );
    const current = settingsStore.get();
    if (current) settingsStore.set({ ...current, thresholds: res.thresholds });
    return res.thresholds;
  }
}

export const settings = new SettingsService();

export interface NumericThresholds {
  temp: { warn: number; crit: number };
  disk: { warn: number; crit: number };
  emmc: { warn: number; crit: number };
}

const DEFAULT_NUMERIC: NumericThresholds = {
  temp: { warn: 75, crit: 85 },
  disk: { warn: 80, crit: 90 },
  emmc: { warn: 0x08, crit: 0x0a },
};

function num(v: string, fallback: number): number {
  const n = Number(v.trim());
  return Number.isFinite(n) ? n : fallback;
}

/** Ayarlar yüklüyse onları, değilse kernel-varsayılanlarını sayısal döner. */
export function thresholdNumbers(): NumericThresholds {
  const t = settingsStore.get()?.thresholds;
  if (!t) return DEFAULT_NUMERIC;
  return {
    temp: {
      warn: num(t.temp.warn, DEFAULT_NUMERIC.temp.warn),
      crit: num(t.temp.crit, DEFAULT_NUMERIC.temp.crit),
    },
    disk: {
      warn: num(t.disk.warn, DEFAULT_NUMERIC.disk.warn),
      crit: num(t.disk.crit, DEFAULT_NUMERIC.disk.crit),
    },
    emmc: {
      warn: num(t.emmc.warn, DEFAULT_NUMERIC.emmc.warn),
      crit: num(t.emmc.crit, DEFAULT_NUMERIC.emmc.crit),
    },
  };
}
